import React, { useContext } from 'react';
import { IExtraProduct } from '../../models/IChainInfo';
import { IExtraItem } from '../../services/WebApiClient';
import { EditorContext } from '../EditorCommon/EditorContext';
import { SortBy } from '../Table/SortBy';
import { IColumn, Table } from '../Table/Table';

export function ExtraItemsList(props: {

}) {

    const ec = useContext(EditorContext);
    function getProduct(ei: IExtraItem): IExtraProduct | undefined {
        return ec.cabinetService.chainInfo.extraProducts
            .flatMap(epg => epg.products)
            .find(ep => ep.id === ei.productId)
    }
    function setCount(ei: IExtraItem, newCount: number | undefined) {
        if (newCount === undefined || Number.isNaN(newCount)) {
            newCount = 0;
        }
        ec.cabinetService.setExtraItemCount(ei.productId, newCount, ei.interiorMaterialId);
    }

    function removeItem(ei: IExtraItem) {
        ec.cabinetService.removeExtraItem(ei.productId);
    }
    function getExternalId(ei: IExtraItem) {
        const product = getProduct(ei);
        if (!product)
            return " -- ";
        const material = product.materials.find(m => m.interiorMaterialId === ei.interiorMaterialId);
        if (!material)
            return product.externalId;
        return material.externalId;
    }
    function getMaterialName(ei: IExtraItem) {
        return getProduct(ei)?.materials.find(m => m.interiorMaterialId === ei.interiorMaterialId)?.name ?? "";
    }
    const columns: IColumn<IExtraItem>[] = [
        {
            content: getExternalId,
            key: "externalId",
            header: ec.translator("extra items list table header externalId", "Varenr."),
            sort: SortBy.String(getExternalId),
        },
        {
            content: ei => getProduct(ei)?.name ?? " -- ",
            key: "name",
            header: ec.translator("extra items list table header name", "Produkt"),
            sort: SortBy.String(ei => getProduct(ei)?.name),
        },
        {
            content: getMaterialName,
            key: "material",
            sort: SortBy.String(getMaterialName),
        },

        {
            key: "count",
            sort: SortBy.Number(ei => ei.count),
            content: ei => {
                //const ref = React.createRef<HTMLInputElement>();
                return (
                    <div className="input-group">
                        <input type="number"
                            className="form-control"
                            style={{ maxWidth: "120px" }}
                            min={1}
                            value={ei.count === 0 ? '' : ei.count}
                            onChange={(evt) => setCount(ei, evt.target.valueAsNumber)}
                        />
                        <div className="input-group-append">
                            <button className="btn btn-outline-danger"
                                type="button"
                                onClick={() => removeItem(ei)}
                            >
                                {ec.translator("extra items list table remove line", "fjern")}
                            </button>
                        </div>
                    </div>
                )
            },
            header: ec.translator("extra items list table header count", "Antal")
        }
    ];

    return (
        <Table<IExtraItem>
            columns={columns}
            rows={ec.cabinet.extraItems}
            rowKey={ei => ei.productId}
        />
    );
}
